export const TYPO_DEFAULTS = { heading_font: "Playfair Display", body_font: "IBM Plex Sans", base_size: 16 };

export const HEADING_FONTS = ["Playfair Display", "Merriweather", "Lora", "EB Garamond", "Cormorant Garamond",
  "Libre Baskerville", "Source Serif 4", "Noto Serif", "Crimson Pro", "DM Serif Display", "Montserrat", "Poppins", "IBM Plex Serif"];

export const BODY_FONTS = ["IBM Plex Sans", "Source Sans 3", "Open Sans", "Lato", "Roboto", "Noto Sans", "Nunito Sans",
  "Work Sans", "DM Sans", "Manrope", "Mukta", "Hind", "Noto Sans Devanagari", "Merriweather Sans"];

// Loads a Google Font family once; falls back to the default weight if weighted variants don't exist.
export function loadGoogleFont(family) {
  if (!family) return;
  const id = `gf-${family.replace(/\s+/g, "-").toLowerCase()}`;
  if (document.getElementById(id)) return;
  const fam = encodeURIComponent(family).replace(/%20/g, "+");
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fam}:wght@400;500;600;700&display=swap`;
  link.onerror = () => { link.href = `https://fonts.googleapis.com/css2?family=${fam}&display=swap`; };
  document.head.appendChild(link);
}

export function applyTypography(t) {
  const root = document.documentElement.style;
  loadGoogleFont(t.heading_font);
  loadGoogleFont(t.body_font);
  root.setProperty("--font-heading", `"${t.heading_font}", Georgia, serif`);
  root.setProperty("--font-body", `"${t.body_font}", -apple-system, sans-serif`);
  root.setProperty("--base-font-size", `${t.base_size}px`);
}
